const isEmailValid = email => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const lowercasedEmail = String(email).toLowerCase();
  const isEmailMatch = lowercasedEmail.match(emailRegex);

  return Boolean(isEmailMatch);
};

export default isEmailValid;
